export const ExtraRuleTypeTo = {
    SECTION: 'SECTION',
    CATEGORY: 'CATEGORY',
    PRODUCTS: 'PRODUCTS',
    SELLER_ALL: 'SELLER_ALL',
} as const;

export type ExtraRuleTypeTo = typeof ExtraRuleTypeTo[keyof typeof ExtraRuleTypeTo];

export const ExtraRuleTypeFrom = {
    PRODUCTS: 'PRODUCTS',
    SET: 'SET',
} as const;

export type ExtraRuleTypeFrom = typeof ExtraRuleTypeFrom[keyof typeof ExtraRuleTypeFrom];

export interface ExtraRule {
    id: number;
    typeTo: ExtraRuleTypeTo;
    idsTo: number[];
    typeFrom: ExtraRuleTypeFrom;
    idsFrom: number[];
    sellerId?: number | null;
    createdAt: string;
    updatedAt: string;
}

export interface CreateExtraRuleDto {
    typeTo: ExtraRuleTypeTo;
    idsTo: number[];
    typeFrom: ExtraRuleTypeFrom;
    idsFrom: number[];
}
